import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export interface EmptyStateProps {
  title: string;
  message?: string;
  /** Override the default inbox glyph, e.g. a lucide icon element. */
  icon?: ReactNode;
  /** Call-to-action node, usually a <Button>. */
  action?: ReactNode;
  className?: string;
}

/** Friendly "nothing here yet" panel for empty lists and searches. */
export function EmptyState({ title, message, icon, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center rounded-lg border border-dashed border-steel-light bg-surface px-6 py-12 text-center ${className}`}>
      <span aria-hidden="true" className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-steel-pale text-steel-soft">
        {icon ?? <Inbox className="h-6 w-6" />}
      </span>
      <h3 className="text-base font-semibold text-ink">{title}</h3>
      {message && <p className="mt-1 max-w-md text-sm text-ink-muted">{message}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
